import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import carrousel1 from "../../assets/images/jynperez-metalurgica-fabrica.png";
import carrousel2Desktop from "../../assets/images/jynperez-metalurgica-fabrica-2.png";
import carrousel2Mobile from "../../assets/images/jynperez-metalurgica-fabrica-2-mobile.png";
import carrousel3Desktop from "../../assets/images/jynperez-metalurgica-fabrica-3.png";
import carrousel3Mobile from "../../assets/images/jynperez-metalurgica-fabrica-3-mobile.png";

import "./Carrousel.css";

const CarrouselComponent = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className="carrousel-container">
            <Carousel controls indicators={false} interval={2000} pause="hover">
                <Carousel.Item>
                    <img
                        className="carousel-image"
                        src={carrousel1}
                        alt="J y N Perez Metalúrgica"
                    />
                </Carousel.Item>
                <Carousel.Item>
                <img
                        className="carousel-image"
                        src={isMobile ? carrousel2Mobile : carrousel2Desktop}
                        alt="J y N Productos Especiales"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="carousel-image"
                        src={isMobile ? carrousel3Mobile : carrousel3Desktop}
                        alt="J y N Productos Especiales"
                    />
                </Carousel.Item>
            </Carousel>
            <div className="carrousel-text-container">
                <h2 className="carrousel-title">
                    Artículos Gastronómicos <br /> En Alambre Y Tejido
                </h2>
                <div className="carrousel-subtitle-container">
                    <p className="carrousel-subtitle">
                        Nos diferenciamos por la calidad y la entrega inmediata
                    </p>
                    <hr className="subtitle-divider" />
                    <p className="carrousel-subtitle-2">
                        Más de 40 años en el rubro gastronómico
                    </p>
                    <hr className="subtitle-divider" />
                </div>
            </div>
        </div>
    );
};

export default CarrouselComponent;
